// extracted by mini-css-extract-plugin
export default {"ScreenThreshold":"600","AsideThreshold":"950","Header":"Header_Header__AkdUN","navContainer":"Header_navContainer__9nOgD"};